import React, { useState } from 'react';
import {Link, useNavigate} from 'react-router-dom';
import { useRegister } from "../stores/authStore";

const ResetPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState(false);

    const { reset, loading, error } = useRegister();

    const validate = () => {
        let newErrors = {};

        if (!email) {
            newErrors.email = "Введите email";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = "Неверный формат email";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        const success = await reset(email);
        if (success) {
            setSuccess(true);
            setTimeout(() => {
                navigate("/detail/login/");
            }, 7000);
        }
    };

    const ErrorText = ({ name }) =>
        errors[name] ? <p className="text-xs text-red-600 mt-1">{errors[name]}</p> : null;

    return (
        <div
            style={{ backgroundImage: `url(https://i.pinimg.com/originals/4f/46/3a/4f463a7eadcb4b6878e1131bea9539d8.jpg)` }}
            className="relative z-20 bg-cover flex items-center min-h-[85vh]"
        >
            <div className="md:w-2/5 mx-auto">
                <div className="flex items-center justify-center rounded-2xl bg-white/45 backdrop-blur-md relative overflow-hidden">
                    <div className="p-8 rounded-lg shadow-md w-full">
                        <h2 className="md:text-2xl text-xl font-semibold mb-6 text-black/70">
                            Сброс пароля
                        </h2>

                        <form className="space-y-4" onSubmit={handleSubmit}>
                            <div>
                                <label htmlFor="email" className="block text-sm mb-1 text-black/70">Email</label>
                                <input
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="email"
                                    id="email"
                                    className="w-full border bg-white/30 rounded-md text-black/70 px-3 py-2 focus:outline-none focus:shadow-md"
                                />
                                <ErrorText name="email" />
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-black/60 duration-300 text-white py-2 rounded-lg hover:bg-black transition"
                            >
                                {loading ? "Отправка..." : "Отправить"}
                            </button>
                            {success && <p className="text-green-600 text-sm mt-2">Новый пароль отправлен на почту</p>}
                            {error && <p className="text-red-600 text-sm mt-2">{error.detail}</p>}
                        </form>

                        <div className="mt-4 text-center">
                            <Link to={'/detail/login/'} className="hover:text-black text-black/70 hover:underline block">
                                Вернуться к входу
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPage;
